import { render, staticRenderFns } from "./RightTop.vue?vue&type=template&id=1564ae07&scoped=true"
import script from "./RightTop.vue?vue&type=script&lang=js"
export * from "./RightTop.vue?vue&type=script&lang=js"
import style0 from "./RightTop.vue?vue&type=style&index=0&id=1564ae07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564ae07",
  null
  
)

export default component.exports